module.exports = __webpack_public_path__ + "img/violet_123.48459329.png";